import {
  Col,
  Form,
  Input,
  Row,
  Select,
  // Button,
  UploadProps,
  Space,
  Upload,
  Divider,
} from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Button from 'components/Button';
import { useEffect, useState } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { useUser } from 'contexts/User';
import { useMutation, useQuery } from 'react-query';
import PortfolioApi from 'apis/PortfolioApi';
import PofTypeApi from 'apis/PofTypeApi';
import { ColumnsType } from 'antd/es/table';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import useQueryParam from 'hooks/useQueryPrams';
import { Table } from 'antd/lib';
import { HocChangePagination } from 'utils/HocChangePagination';
import ProductApi from 'apis/ProductApi';
import * as XLSX from 'xlsx';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import AllocateCreate from 'pages/Branch/Allocate/AllocateCreate';
import { allocationDetails } from 'interface/allowcate.interface';
import { openNotificationWithIcon } from 'utils/notification';
import AllocateApi from 'apis/AllocateApi';
import formatCurrencyVND from 'utils/formatCurrencyVND';

interface Iparam {
  id?: string;
}

export default function StepList(): JSX.Element {
  const { id } = useParams<Iparam>();
  const allocateData = useLocation().state as any;
  const allocateDetail = allocateData?.declareDetail;
  const [dataImport, setDataImport] = useState<any>();
  const [capitalBranchData, setCapitalBranchData] = useState<any>();

  const history = useHistory();
  const { user } = useUser();

  const [form] = Form.useForm();
  const dateFormat = 'DD/MM/YYYY';
  const queryParam = useQueryParam();

  const setStep = useCategoryManagementStore((state) => state.setStep);

  const { data: lstPofType } = useQuery(['getAll'], () => PofTypeApi.getAll());
  const [excelData, setExcelData] = useState<allocationDetails[]>([]);
  const [fileName, setFileName] = useState<string>();
  const [checkCapitalValue, setCheckCapitalValue] = useState<any>();

  const { data: porfolioDetail, isLoading } = useQuery(
    ['get'],
    () => PortfolioApi.getDetail(id || ''),
    { enabled: !!id }
  );

  const page = parseInt(queryParam.get('page') + '') || 1;

  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const functionParams = {
    page: page,
    page_size: page_size,
  };

  const params = JSON.parse(JSON.stringify(functionParams));

  type FixedType = 'left' | 'right' | boolean;
  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 100,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mã cửa hàng',
      dataIndex: 'shop_code',
      width: 150,
    },
    {
      title: 'Vốn phân bổ tối thiểu (min)',
      width: 180,
      dataIndex: 'capital_min',
      render: (value) => {
        return formatCurrencyVND(value);
      },
    },
    {
      title: 'Vốn phân bổ tối đa (max)',
      width: 180,
      dataIndex: 'capital_max',
      render: (value) => {
        return formatCurrencyVND(value);
      },
    },
    {
      title: '',
      fixed: 'right' as FixedType,
      width: 10,
    },
  ];

  const { data, isLoading: getUsersLoading } = useQuery([], () =>
    ProductApi.get()
  );

  useEffect(() => {
    setStep(1);
  }, [form, porfolioDetail]);

  const validateMessages = {
    required: '${label} không được để trống!',
  };

  function handleFileChange(info: UploadProps) {
    if (info.fileList) {
      const files = info.fileList.map((file: any) => {
        return file.originFileObj;
      });
      if (files.length != 0) {
        const file = info.fileList[0];
        // setSelectedFile(file);
        const reader = new FileReader();
        setFileName(file.name);
        let checkTotalCapital = 0;
        reader.onload = (e) => {
          if (e.target) {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const excelData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
              header: 1,
              range: 0,
            });
            // console.log(excelData);
            let jsonData: any = [];
            for (let i = 1; i < excelData.length; i++) {
              if (excelData[0].length < 3) {
                openNotificationWithIcon(
                  'error',
                  'Template file excel không đúng!'
                );
                jsonData = [];
                break;
              }
              const paramData = excelData[i];
              if (paramData.length > 0) {
                if (paramData[0] == undefined || paramData[0] == null) {
                  openNotificationWithIcon('error', 'Thiếu mã cửa hàng!');
                  jsonData = [];
                  break;
                }
                let count = 0;
                for (let j = i + 1; j < excelData.length; j++) {
                  const paramDataJ = excelData[j];
                  if (paramDataJ[0] == undefined || paramDataJ[0] == null) {
                    continue;
                  }
                  if (paramData[0] == paramDataJ[0]) {
                    count++;
                  }
                  if (count > 0) break;
                }
                if (count > 0) {
                  openNotificationWithIcon(
                    'error',
                    'Mã cửa hàng ' + paramData[0] + ' đang bị trùng!'
                  );
                  jsonData = [];
                  break;
                }
                if (
                  paramData[1] == undefined ||
                  paramData[1] == null ||
                  Number(paramData[1]) <= 0
                ) {
                  openNotificationWithIcon(
                    'error',
                    'Mã cửa hàng ' +
                      paramData[0] +
                      ' Thiếu số tiền Vốn phân bổ tối thiểu (min)!'
                  );
                  jsonData = [];
                  break;
                }
                if (
                  paramData[2] == undefined ||
                  paramData[2] == null ||
                  Number(paramData[2]) <= 0
                ) {
                  openNotificationWithIcon(
                    'error',
                    'Mã cửa hàng ' +
                      paramData[0] +
                      ' Thiếu số tiền Vốn phân bổ tối đa (max)!'
                  );
                  jsonData = [];
                  break;
                }
                if (Number(paramData[2]) < Number(paramData[1])) {
                  openNotificationWithIcon(
                    'error',
                    'Mã cửa hàng ' +
                      paramData[0] +
                      ' Số tiền Vốn Max phải lớn hơn Số tiền vốn Min!'
                  );
                  jsonData = [];
                  break;
                }
                if (
                  Number.isNaN(Number(paramData[1])) ||
                  Number.isNaN(Number(paramData[2]))
                ) {
                  openNotificationWithIcon(
                    'error',
                    'Mã cửa hàng ' +
                      paramData[0] +
                      ' Sai định dạng dữ liệu cột số tiền. Vui lòng nhập lại!'
                  );
                  jsonData = [];
                  break;
                }
                const param = {
                  shop_code: String(paramData[0]),
                  capital_min: paramData[1],
                  capital_max: paramData[2],
                } as unknown as allocationDetails;
                jsonData.push(param);
                checkTotalCapital = checkTotalCapital + paramData[2];
              }
            }
            setExcelData(jsonData);
            setDataImport(jsonData);
            setCheckCapitalValue(Number(checkTotalCapital));
          }
        };

        const blob = file.originFileObj as Blob;
        reader.readAsArrayBuffer(blob);
      } else {
        setFileName(undefined);
      }
    } else {
      setFileName(undefined);
    }
  }

  const { mutate: importAllocationDetail } = useMutation(
    AllocateApi.importAllocationDetail,
    {
      onSuccess: (data: any) => {
        if (data.success === false) {
          openNotificationWithIcon('error', data.message);
        } else {
          const param = {
            capitalBranchId: capitalBranchData.id,
            status: 0,
          };
          saveAllocation(param);
        }
      },
      onError: () => {
        openNotificationWithIcon('error', 'Import thất bại');
      },
    }
  );

  const { mutate: createAllocation } = useMutation(
    AllocateApi.createAllocation,
    {
      onSuccess: (res: any) => {
        console.log(res);
        if (res?.status == 'success') {
          const data = {
            capital_branch_id: res.data.id,
            data: dataImport,
            capital_year:
              res?.data?.capital_year ?? allocateDetail?.capital_year,
          };
          setCapitalBranchData(res.data);
          importAllocationDetail(data);
        } else {
          openNotificationWithIcon('error', res.message);
        }
      },
      onError: (e: any) => {
        openNotificationWithIcon('error', e.toString());
      },
    }
  );

  function generateExcel() {
    const data = [];

    // create title
    const headerRow = columns.map((column) => {
      if (column.title != 'STT') return column.title;
    });

    data.push(headerRow.slice(1, 4));

    // create data
    excelData.forEach((prm) => {
      const rowData = columns.map((column) => {
        return prm[column.dataIndex];
      });
      data.push(rowData.slice(1, 4));
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `mau_danh_sach_phan_bo.xlsx`);
  }

  const { mutate: saveAllocation } = useMutation(AllocateApi.saveAllocate, {
    onSuccess: (data: any) => {
      if (data.success === true) {
        openNotificationWithIcon('success', 'Thêm mới thành công');
        history.push(`/branchs-capital-detail`, allocateDetail);
      }
    },
    onError: () => {
      openNotificationWithIcon('error', 'Thêm mới thất bại');
    },
  });

  const handleSave = async () => {
    if (checkCapitalValue > allocateDetail.capital_value) {
      openNotificationWithIcon(
        'error',
        'Tổng vốn phân bổ cửa hàng lớn hơn tổng vốn chi nhánh đã khai báo!'
      );
    } else {
      createAllocation(allocateDetail);
    }
  };

  return (
    <AllocateCreate isLoading={isLoading}>
      <div className="mb-4 flex flex-col gap-4 pb-20">
        <Content>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
            align="middle"
            className="mb-3"
          >
            <Col span={12}>
              <div className="text-xl font-bold">2. Danh sách phân bổ</div>
            </Col>
            <Col span={12}>
              <Row justify="end" align="middle">
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    customClass="fix-border-radius"
                    onClick={generateExcel}
                  >
                    <DownloadOutlined />
                    Tải file excel
                  </Button>
                </Space>
              </Row>
            </Col>
          </Row>
          <Form layout="vertical">
            <Row align="middle" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={21}>
                <Form.Item
                  label="Danh sách phân bổ"
                  rules={[{ required: true }]}
                >
                  <Input
                    disabled={true}
                    placeholder="nhập file"
                    className=""
                    value={fileName}
                  />
                </Form.Item>
              </Col>
              <Col span={3} className="flex justify-end">
                <Upload
                  accept=".xlsx,.xls,.csv"
                  onChange={handleFileChange}
                  beforeUpload={() => false}
                  fileList={[]}
                  showUploadList={false}
                >
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    customClass="fix-border-radius"
                  >
                    Browser
                  </Button>
                </Upload>
              </Col>
            </Row>
          </Form>
          {excelData.length > 0 && (
            <Table
              rowKey={(record) => record.id}
              columns={columns}
              scroll={{ x: 958 }}
              className="customTable"
              dataSource={excelData}
              pagination={{
                className: 'flex items-center',
                current: page,
                pageSize: page_size,
                // total: data?.total,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50'],
                onChange: HocChangePagination(history),
              }}
            />
          )}
        </Content>
        <Divider
          style={{
            borderTop: '1px solid rgba(0, 0, 0, 0.2)',
            marginTop: '8px',
            marginBottom: '8px',
          }}
        />
        <Row
          className="mt-8"
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
          style={{ marginTop: '20px', marginRight: '2px' }}
        >
          <Col className="flex justify-end">
            <Button
              onClick={() =>
                history.push(`/branchs-capital-detail`, allocateDetail)
              }
              customClass="mr-1"
            >
              Trở lại
            </Button>
            {/* <Button
              disabled={excelData.length > 0 ? false : true}
              bgColor={excelData.length > 0 ? 'bg-green-500' : 'bg-gray-300'}
              onClick={handleSaveDraft}
              customClass="mr-1"
            >
              Lưu tạm
            </Button> */}
            <Button
              disabled={excelData.length > 0 ? false : true}
              bgColor={excelData.length > 0 ? 'bg-primary-50' : 'bg-gray-300'}
              onClick={handleSave}
            >
              Lưu và phân bố
            </Button>
          </Col>
        </Row>
        {/* </Form> */}
      </div>
    </AllocateCreate>
  );
}
